export interface PuiPortletTabHeader {
  title: string;
  description: string;
}
